<template>
  <div class="footer">
    <div class="footerTops" @click="jump(1)">
      <img  class="footerTopsImg" src="@/assets/images/xiu/footer_icon_discipline.png" alt="" srcset="">
      甘肃省纪委监委派驻省总工会机关纪检监察组
    </div>
    <div class="copyright">
      <img  @click="jump(11)" class="footer-logo" src="@/assets/images/footer/dzlogo.png" alt="" />
      <!-- <span @click="jump(5)">甘肃省纪委监委派驻省总工会机关纪检监察组</span> -->
    </div>
    
    <div class="line"></div>
    <div class="footer-info">
      <div class="info-left">
        <span>主办单位：甘肃省总工会 版权所有</span>
        <span>通讯地址：甘肃省兰州市城关区东郊巷26号</span>
        <span>邮编：730000</span>
      </div>
      <div class="info-right">
        <span>技术支持：建朗科技</span>
        <div class="code">
          <img @click="openOver(1)" src="@/assets/images/footer/wechat.png" alt="" />
          <img @click="openOver(2)" src="@/assets/images/footer/szlogo.png" alt="" />
          <img @click="openOver(3)" src="@/assets/images/footer/mini.png" alt="" />
          <img @click="openOver(4)" src="@/assets/images/footer/douyin.png" alt="" />
        </div>
      </div>
    </div>
    <div class="line"></div>
    <div class="copyright">
      <img @click="jump(2)" src="@/assets/images/footer/ba.png" alt="" />
      <span @click="jump(3)">陇ICP备16000114号</span>
      <span @click="jump(4)">陇公网安备 11010202001902号</span>
    </div>
   
    <van-overlay :z-index="999999" :show="show" @click="show = false">
      <div class="wrapper" @click.stop>
        <div class="qrcode-wrap">
          <div class="qrcoe-title">甘肃总工会</div>
          <img :src="src" alt="">
          <div class="qrcode-tips ">(长按二维码进行保存)</div>
        </div>
        <div @click="show = false" class="close">
          <van-icon size="36" color="#ffffff" name="close" />
        </div>

      </div>
    </van-overlay>
  </div>
</template>
  
<script>
import Vue from 'vue';
import {  Overlay } from 'vant';
Vue.use(Overlay);
export default {
  data() {
    return {
      show: false,
      src:"",
    };
  },
  methods: {
    openOver(type) {
      switch (type) {
        case 1:
          this.src = require('@/assets/images/footer/w1.jpg');
          break;
        case 2:
          this.src = require('@/assets/images/footer/w2.jpg');
          break;
        case 3:
          this.src = require('@/assets/images/footer/w3.jpg');
          break;
        case 4:
          this.src = require('@/assets/images/footer/w4.png');
          break;       
          default:
      }
      this.show = true
    },
    jump(type) {
      switch (type) {
        case 1:
          window.open("https://www.gsgh.org.cn/#/detail?newsId=2385");
          break;
        case 2:
          window.open("https://beian.mps.gov.cn/#/query/webSearch");
          break;
        case 3:
          window.open("https://beian.mps.gov.cn/#/query/webSearch");
          break;
        case 4:
          window.open("https://beian.miit.gov.cn/#/Integrated/index");
          break;
        case 11:
          window.open("https://bszs.conac.cn/sitename?method=show&id=07B5DB20B8E74F92E053022819AC7839");
          break;
        case 5: 
        this.$router.push({
          path: "/detail",
          query: {
            newsId: 2385,
          },
        }); 
          break;
          default:
      }
         
    },
  },
};
</script>
  <style scoped lang="scss">
.footer {
  position: relative;
  bottom: 1px;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-around;
  height: 455px;
  background: #c90c0c;
  border-radius: 0px 0px 0px 0px;
  padding-bottom: constant(safe-area-inset-bottom);
  padding-bottom: env(safe-area-inset-bottom);
  .footerTops{
    font-size: 28px;
    padding: 10px 0;
    text-align: center;
    background: #E9E9E9;
    width: 100%;
    .footerTopsImg{
      display: inline-block;
      width: 24px;
      height: 24px;
    }
  }
  .wrapper {
    overflow: hidden;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    height: 100%;

    .qrcode-wrap {
      position: relative;
      width: 68.6667vw;
      background: #fff;
      border-radius: 8px;
      padding: 2.6667vw 0;
      display: flex;
      justify-content: center;
      flex-direction: column;
      align-items: center;

      .qrcoe-title {
        margin: 0 0 1.3333vw 0;
        font-size: 4.2667vw;
        color: #333;
        text-align: center;
        font-weight: 400;
      }

      img {
        width: 63.3333vw;
        height: 63.3333vw;
        margin-bottom: 1.3333vw;
      }

      .qrcode-tips {
        text-align: center;
        font-size: 3.4667vw;
        color: #7c8084;
      }

    }

    .close {
      margin-top: 8px;
      z-index: 999999;
    }
  }
  .line {
    width: 95%;
    height: 0px;
    border: 1px solid #ffffff;
    opacity: 0.3;
  }
  .footer-logo {
    width: 62px;
    height: 76px;
    cursor: pointer !important;
  }
  .footer-info {
    display: flex;
    justify-content: space-between;
    height: 200px;
    font-family: PingFang SC, PingFang SC;
    font-weight: 400;
    font-size: 24px;
    color: #ffffff;
    line-height: 48px;
    text-align: left;
    font-style: normal;
    text-transform: none;
    width: 95%;
    .info-left {
      width: 75%;
      height: 100%;
      border-radius: 0px 0px 0px 0px;
      span{
        display: block;
        // line-height: 30px;
      }
    }
    .info-right {
      width: 40%;
      height: 100%;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: flex-end;
      border-radius: 0px 0px 0px 0px;
      .code {
        height: 160px;
        width: 200px;
        display: flex;
        justify-content: space-evenly;
        align-items: center;
        flex-wrap: wrap;
        img {
          width: 70px;
          height: 70px;
        }
      }
    }
  }
  .copyright {
    height: 100px;
    width: 100%;
    border-radius: 0px 0px 0px 0px;
    display: flex;
    justify-content: space-evenly;
    align-items: center;
    font-family: PingFang SC, PingFang SC;
    font-weight: 400;
    font-size: 24px;
    color: #ffffff;
    line-height: 56px;
    text-align: left;
    font-style: normal;
    text-transform: none;
    
  
    span {
      pointer-events: auto;
      cursor: pointer !important;
    }
    img {
      width: 40px;
      height: 40px;
    }
  }
}
</style>